import React from 'react';
import Router from './Views/Routes/router';
import './App.css';
import { ToastContainer } from 'react-toastify';

function App() {
	return (
		<div className='App'>
			<ToastContainer closeButton={true} autoClose={1000} />
			<Router />
		</div>
	);
}

export default App;
